import React, {Component} from 'react';
import "../../../css/tableStyles.css";
import "./foodtable.css";
import ExpandButton from '../ExpandButton';

const FlexRow = (props) => {
    return (<div className="flexRow rowmain">
        <div className="flexCell">{props.item.FoodInspViolation}</div>
        <div className="flexCell ">{props.item["Inp. Date"]}</div>
    </div>)
}

class FoodTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false
        }
        this.renderCutoff = this.renderCutoff.bind(this);
        this.renderAllRows = this.renderAllRows.bind(this);
        this.handleClicked = this.handleClicked.bind(this);



        // const sorted = this.props.reports.sort(function(a,b) {
        //     return (a.Test_Result < b.Test_Result) ? 1 : ((b.Test_Result > a.Test_Result) ? -1 : 0)
        // } )

    }

    handleClicked() {
        this.setState({
            clicked: !this.state.clicked
        })
    }


    renderCutoff() {
        return (this.props.reports.slice(0, 5).map((item,i) => <FlexRow item={item} key={i}/>))
    }

    renderAllRows() {
        return (this.props.reports.map((item,i) => <FlexRow item={item} key={i}/>))
    }

    render() {
        const reports = this.props.reports;
        let cutoff = this.props.reports.length > 5 ? true : false;

        if(reports.length > 0) {
            return (
                <div>
                    <div className="tableTitle">Food inspection reports:</div>
                    <div className="table-wrap table-food">
                        <div className="flexTable">
                            <div className="flexTableHead">
                                <div className="flexCell">Food Inspection Violation</div>
                                <div className="flexCell">Inpsection Date</div>
                            </div>

                            {
                                (() => {
                                    if (cutoff && !this.state.clicked) {
                                        return this.renderCutoff()
                                    } else if (cutoff && this.state.clicked) {
                                        return this.renderAllRows()
                                    } else {
                                        return this.renderAllRows()
                                    }

                                })()
                            }
                            {
                                (() => {
                                    if(reports.length > 5) {
                                        return (<ExpandButton length={this.props.reports.length} clicked={this.state.clicked} onStateChange={this.handleClicked}/>)
                                    }
                                })()
                            }


                        </div>

                    </div>
                </div>
                    )
                    }
                    else {
                        return (
                <div className="">
                    {/* No signs of rodent or insect infestations were found during 2017-18 inspections. */}
                </div>
            )
        }

    }
}

export default FoodTable;



// WEBPACK FOOTER //
// ./src/components/tables/food/foodtable.js